const generateQueryKeyFromObject = (object: object): string[] =>
  Object.entries(object)
    .map(([key, value]) => `${key}-${value}`)
    .sort();

export default generateQueryKeyFromObject;
